import React, { Component } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';

export default class StandsTooltip extends Component {

    constructor(props) {
        super(props);

        this.state = {
            stands: [],
            loading: false
        };
    }

    componentDidMount() {
        var scope = this;
        var token = localStorage.getItem("token");
        this.setState({ loading: true});
        fetch('api/Environment/GetEnvironments?projectId=' + this.props.projectId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ stands: result, loading: false});
                }).catch((err) => console.log(err));
            }
        });
    }

    render() {

        return (
            <div className="stands-tooltip-block clearfix" >
                <div className="stands-tooltip-close">
                    <IconButton onClick={() => { this.props.close() }} size="large">
                        <CloseIcon />
                    </IconButton>
                </div>
                {this.state.loading && <CircularProgress color="inherit" />}
                <div style={{ "width": "90%", "display": "grid" }}>
                    {this.state.stands.map(s => <a className="stand-link" onClick={() => this.props.close()} target="_blank" rel="noreferrer noopener" href={s.link}>{s.name} {s.typeName}</a>)}
                </div>
            </div>
        );
    }
}
